
import { useI18n } from "vue-i18n";
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Field, Cell, Icon, ActionSheet } from "vant";

export default defineComponent({
  name: "INPUT",
  props: ["type", "expand", "placeholder", "modelValue"],
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet
  },
  setup(props, content) {
    const route = useRoute();
    const { t } = useI18n();
    const value = ref(props.modelValue);

    const onInputHandler = val => {
      content.emit("update:modelValue", val);
    };

    const clear = () => {
      value.value = "";
      content.emit("update:modelValue", "");
    };

    onMounted(() => {});

    return {
      value,
      clear,
      onInputHandler
    };
  }
});
